module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-G-4-Social-Static-Ad.bd8cb8fa.webp";